import { IConsultantProfile } from "../types-ensure";
import { hasPendingRequestToJoin } from "./hasPendingRequestToJoin";
import { isBlocked } from "./isBlocked";

export const isActive = (profile: IConsultantProfile) => {
  if (isBlocked(profile)) {
    return false;
  }

  if (hasPendingRequestToJoin(profile)) {
    return false;
  }

  return true;
};
